import { Component, Input, OnInit } from '@angular/core';
import { ConfigLandignPage } from 'src/app/shared/models/ConfigLandingPage';
import { Utils } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.css']
})
export class SponsorsComponent implements OnInit {
  @Input() sponsors;
  @Input() configLandingPage: ConfigLandignPage;
  url = environment.filesUrl;
  @Input() lang: string;
  @Input() isPartners: boolean = false;
  constructor() { }

  ngOnInit(): void {

  }

  getValueTranslate (columnName: string) {
    return Utils.getValueTranslate(this.lang, this.configLandingPage, columnName);
  }

}
